// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3fPkP","subheader":"ReorderModal_subheader__1i7Uq","listWrap":"ReorderModal_listWrap__3KURg"};